import { motion } from "framer-motion";
import { Users, Radio, Target, Mic2 } from "lucide-react";

const pillars = [
 {
 icon: Radio,
 kicker: "Live",
 title: "In real time.",
 body: "Every session is live. No pre-recorded fluff. You show up, we show up, the work gets done.",
 },
 {
 icon: Users,
 kicker: "Community",
 title: "In the room.",
 body: "Writers, artists, producers and supervisors building together. You don't watch. You participate.",
 },
 {
 icon: Target,
 kicker: "Real Stakes",
 title: "Real briefs, real pitches.",
 body: "Active opportunities. Active supervisors. Your work doesn't end in a notebook. It ends in premium songs capturing the attention of supervisors and brands that bring placements.",
 },
 {
 icon: Mic2,
 kicker: "Craft",
 title: "Feedback that lands.",
 body: "Executive-level critique from people who've done the work. No coddling, no theory. Just what the song actually needs.",
 },
];

export default function Experience() {
 return (
 <section
 data-testid="experience-section"
 className="relative bg-ink-800 py-24 md:py-36 border-y border-ink-600"
 >
 <div className="max-w-7xl mx-auto px-4 md:px-8">
 <motion.div
 initial={{ opacity: 0, y: 24 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.6 }}
 className="max-w-4xl"
 >
 <p className="tag-kicker">How this is different</p>
 <h2 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-normal mt-5">
 This isn't a course.
 <br />
 <span className="text-amber italic">It's an experience.</span>
 </h2>
 <p className="mt-7 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed">
 Courses hand you a PDF, some videos and a finish line. Underground
 Mix puts you in the room. Week after week. With executive
 feedback, active briefs, and real accountability. You don't just
 learn sync.{" "}
 <span className="text-white font-semibold">
 You embody it through teaching, coaching and execution.
 </span>
 </p>
 </motion.div>

 <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
 {pillars.map((p, i) => (
 <motion.div
 key={p.kicker}
 initial={{ opacity: 0, y: 24 }}
 whileInView={{ opacity: 1, y: 0 }}
 viewport={{ once: true }}
 transition={{ duration: 0.5, delay: i * 0.08 }}
 data-testid={`experience-pillar-${p.kicker.toLowerCase().replace(/\s/g, "-")}`}
 className="relative p-7 border border-ink-600 bg-ink-900 hover:border-amber/50 transition-colors"
 >
 <div className="flex items-center gap-3 mb-5">
 <span className="h-10 w-10 flex items-center justify-center bg-amber/10 border border-amber/30 text-amber rounded-sm">
 <p.icon size={18} />
 </span>
 <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber font-semibold">
 {p.kicker}
 </span>
 </div>
 <h3 className="font-display text-xl md:text-2xl font-bold leading-tight text-white">
 {p.title}
 </h3>
 <p className="mt-3 text-sm text-white/65 leading-relaxed">
 {p.body}
 </p>
 </motion.div>
 ))}
 </div>
 </div>
 </section>
 );
}
